import { cn } from "@scott/ui/utils/cn";
import { cva, type VariantProps } from "class-variance-authority";

const bodyVariants = cva("font-normal font-paragraph tracking-wide", {
  variants: {
    size: {
      "3xl": "text-3xl",
      "2xl": "text-2xl",
      lg: "text-lg",
      xl: "text-xl",
      base: "text-base",
      sm: "text-sm",
      xs: "text-xs",
    },
    color: {
      default: "text-neutral-dark",
      danger: "text-danger-medium",
    },
    weight: {
      normal: "font-normal",
      bold: "font-bold",
    },
  },
  defaultVariants: {
    size: "base",
    color: "default",
    weight: "normal",
  },
});

interface BodyProps extends VariantProps<typeof bodyVariants> {
  children: React.ReactNode;
  className?: string;
}

const Body = ({ children, className, ...props }: BodyProps) => (
  <p className={cn(bodyVariants({ ...props }), className)}>{children}</p>
);

export { Body, bodyVariants, type BodyProps };
